import { render, staticRenderFns } from "./receiptT.vue?vue&type=template&id=00177b63&scoped=true"
import script from "./receiptT.vue?vue&type=script&lang=js"
export * from "./receiptT.vue?vue&type=script&lang=js"
import style0 from "./receiptT.vue?vue&type=style&index=0&id=00177b63&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00177b63",
  null
  
)

export default component.exports